import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { messages } from '../messages';
import Global from '../../../store/global-selectors';
import FormsColumn from '../../columns/forms-column';

const FormColumnContainer = ({ fulfillmentId }) => {
  const { labelFulfillment } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { hasCustomsFormFile } = labelFulfillment ?? {};

  return hasCustomsFormFile ? <FormsColumn fulfillmentIds={[fulfillmentId]} /> : '';
};

FormColumnContainer.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const Forms = {
  getMessageDescriptor: () => messages.forms,
  id: 'forms',

  render: (data) => {
    if (!data) {
      return '';
    }
    return <FormColumnContainer fulfillmentId={data.id} />;
  },
};
